import { useDispatch, useSelector } from 'react-redux';
import Sidebar from '../../components/sidebar/Sidebar';
import './ManageBanks.css';
import { isLoggedIn, selectToken } from '../login/loginSlice';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { banksAreLoading, loadBanks, loadBanksFailed, selectBanks } from './manageBanksSlice';
import { changeBankSettings, editModeActive, toggleEditMode } from '../manageBankSettings/bankSettingsSlice';
import SearchBar from '../searchBar/SearchBar';
import { changeSearchMode, changeSearchTarget, changeSearchTargetOptions, selectFilters, selectSearchMode } from '../searchBar/searchBarSlice';
import Filter from '../../components/filter/Filter';

export default function ManageBanks() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const loggedIn = useSelector(isLoggedIn);
    const loadingBanks = useSelector(banksAreLoading);
    const loadingBanksFailed = useSelector(loadBanksFailed);

    const banks = useSelector(selectBanks);
    const editModeIsActive = useSelector(editModeActive);

    const searchMode = useSelector(selectSearchMode);
    const searchFilters = useSelector(selectFilters);
    const bankFilters = searchFilters.filter(filter => filter.searchMode === 'bank');
    
    const filteredBanks = bankFilters.length < 1 ? banks : banks.filter(bank => {
        let filterCheck = true;

        bankFilters.forEach(filter => {
            if (filter.active && filterCheck) {
                if (filter.searchTarget === 'Bank Id') {
                    filterCheck = bank.bankId.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Bank Name') {
                    filterCheck = bank.bankName.includes(filter.searchTerm);
                }
            }
        })
        return filterCheck;
    })
    
    useEffect(() => {
        if (!loggedIn) {
            navigate('../login');
        }
    })

    useEffect(() => {
        dispatch(loadBanks(token))
    }, [token, dispatch]);

    useEffect(() => {
        if (searchMode !== 'bank') {
            dispatch(changeSearchMode('bank'));
            dispatch(changeSearchTargetOptions(['Bank Id', 'Bank Name']));
            dispatch(changeSearchTarget('Bank Name'));
        } 
    })

    const handleEditBankClick = (event) => {
        const bankId = event.target.value;
        const bank = banks.filter(bank => bank.bankId === bankId)[0];
        navigate(`../${bankId}/admin/bank`);
        dispatch(changeBankSettings(bank));
        if (!editModeIsActive) {
            dispatch(toggleEditMode());
        }
    }

    return (
        <main>
            <Sidebar />
            <section className='manage-banks'>
                <div>
                    <h2>Manage Banks</h2>
                </div>
                <div>
                    <SearchBar />
                </div>
                <div className='filters'>
                    {bankFilters.map(filter => <Filter filter={filter}/>)}
                </div>
                {loadingBanks ? <h3>Loading Banks...</h3> : 
                    loadingBanksFailed ? <h3>Failed to Load Banks. Please submit a support ticket to resolve the issue</h3> : 
                        <table>
                            <thead>
                                <tr>
                                    <th>Edit</th>
                                    <th>Bank Id</th>
                                    <th>Bank Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredBanks.map((bank) => {
                                    return (
                                        <tr key={bank.bankId}>
                                            <td><button onClick={handleEditBankClick} value={bank.bankId}>Edit</button></td>
                                            <td>{bank.bankId}</td>
                                            <td>{bank.bankName}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>}
            </section>
        </main>
    )
}